<template>
  <div id="iconography">
    <div class="row">
      <div class="text-right col-md-6 offset-md-6 col-xxl-4 offset-xxl-8 mb-5">
        <input v-if="currentNavTab !== 'usage'" v-model="search" placeholder="Search icon" type="text" class="form-control" />
      </div>
    </div>
  <!-- Tab panes -->
    <!-- icon library -->
    <div class="tab-content">
      <div class="tab-pane" :id="iconComponentsData[iconComponent.name].name.toLowerCase().replace(' ', '-')" role="tabpanel" :aria-labelledby="iconComponentsData[iconComponent.name].name.toLowerCase().replace(' ', '-') + '-tab'"
        v-for="(iconComponent) in iconComponents"
        :key="iconComponent.name"
        :class="{ active: currentNavTab === iconComponentsData[iconComponent.name].name }"
      >
        <div
          :is="iconComponent"
          :searchResult="searchResult"
          @update-icon-name="updateIconComponentDataName"
          @update-icon-description="updateIconComponentDataDescription"
          @update-icon-number-of-icons="updateIconComponentDataNumberOfIcons"
          @search-icons="searchIcons"
        >
        </div>
      </div>
      <div class="tab-pane" :id="iconComponentsData['usage'].name.toLowerCase().replace(' ', '-')" role="tabpanel" :aria-labelledby="iconComponentsData['usage'].name.toLowerCase().replace(' ', '-') + '-tab'"
        :class="{ active: currentNavTab === '' || currentNavTab === 'usage' }"
      >
        <section class="md" v-html="mdfile"></section>
      </div>
    </div>
         
  </div>
</template>

<script>
import Icons from '@/components/icons/Icons.vue'
import Illustrations from '@/components/icons/Illustrations.vue'
import mdfile from "@/docs/foundations/iconography.md";

let title = 'Iconography'
let tagline = 'The design of system icons is simple, modern, friendly, and sometimes quirky. Each icon is reduced to its minimal form, with every idea edited to its essence. The designs ensure readability and clarity even at small sizes.'

let iconComponents = [
  Icons,
  Illustrations
]
// Create object to display of icons based on search. Feature was implemented before state management (Vuex) was brought in.
// Data passed to Body.vue and Nav.vue
let iconComponentsData = {}
iconComponentsData['order'] = []
iconComponentsData['usage'] = {
  name: 'usage',
  description: 'How to use',
  numberOfIcons: -1,
}
iconComponentsData['order'].push('usage')

for (let iconComponent of iconComponents) {
  iconComponentsData[iconComponent.name] = {
    name: '',
    description: '',
    numberOfIcons: 0,
  }
  iconComponentsData['order'].push(iconComponent.name)
}


export default {
  name: 'iconography',
  data () {
    return {
      iconComponents,
      iconComponentsData,
      currentIconComponent: iconComponents[0],
      searchResult: {},
      mdfile
    }
  },
  beforeCreate: function () {
    this.$emit('update-title', title) 
    this.$emit('update-tagline', tagline) 
    this.$emit('update-nav', iconComponentsData) 
  },
  computed: {
    search: {
      get () {
        return this.$store.state.searchIcons.search
      },
      set (value) {
        this.$store.commit('searchIcons/updateSearch', value)
      }
    }
  },
  methods: {
    updateIconComponentDataName: function (iconComponentName, newName) {
      this.iconComponentsData[iconComponentName].name = newName
    },
    updateIconComponentDataDescription: function (iconComponentName, newDescription) {
      this.iconComponentsData[iconComponentName].description = newDescription
    },
    updateIconComponentDataNumberOfIcons: function (iconComponentName, newNumber) {
      this.iconComponentsData[iconComponentName].numberOfIcons = newNumber 
    },
    searchIcons: function (iconTypeName, icons) {
      let self = this
      let searchMatchIconsResult = icons.filter(function(icon) {
        return self.search === '' ||
        icon.toLowerCase().replace(/_/g, ' ').includes(self.search.toLowerCase()) ||
        icon.toLowerCase().replace(/_/g, '-').includes(self.search.toLowerCase()) ||
        icon.toLowerCase().replace(/-/g, ' ').includes(self.search.toLowerCase())
      })
      this.searchResult['name'] = iconTypeName
      this.searchResult['result'] = searchMatchIconsResult
    }
  },
  props : {
    currentNavTab: {
      default: '',
      type: String
    }
  }
}
</script>
